import React, { useState, useEffect } from "react";
import classNames from "classnames/bind";
import { shape, number, any, bool, string, node } from "prop-types";
import * as styles from "./SliderPagination.module.scss";

const cx = classNames.bind(styles);

const SliderPagination = ({
	swiperRefLoaded,
	swiperRef,
	totalSlides,
	paginationClasses,
	paginationBulletMessage,
	moreLink,
	slidesPerPage,
}) => {
	const [currentIndex, setCurrentIndex] = useState(0);

	const handleClick = index => swiperRef.current.slideTo(index);

	useEffect(() => {
		if (swiperRefLoaded && swiperRef.current) {
			swiperRef.current.on("slideChange", () =>
				setCurrentIndex(swiperRef?.current?.realIndex ?? 0)
			);
		}
	}, [swiperRefLoaded, swiperRef]);

	const paginationButtons = [];
	for (let index = 1; index <= totalSlides; index++) {
		const slideIndex = index - 1;
		let isActive = false;
		if (currentIndex + slidesPerPage >= totalSlides) {
			// For the last page
			if (
				slideIndex + slidesPerPage >= totalSlides &&
				(currentIndex < slideIndex || currentIndex < slidesPerPage + slideIndex)
			)
				isActive = true;
		} else if (slidesPerPage === 0 && currentIndex === slideIndex) {
			// For the first page
			isActive = true;
		} else {
			isActive = currentIndex >= slideIndex && currentIndex < slidesPerPage + slideIndex; // For all the other page
		}

		if (slidesPerPage === 0 || index === 1 || slideIndex % slidesPerPage === 0)
			paginationButtons.push(
				<li
					key={`slide-index-${slideIndex}`}
					className={cx("paginationItem", paginationClasses.paginationItem)}>
					<button
						className={cx(
							"bullet",
							paginationClasses.bullet,
							{
								bulletActive: isActive,
							},
							{
								[paginationClasses.bulletActive]: isActive,
							}
						)}
						type="button"
						aria-label={paginationBulletMessage.replace("{{index}}", index)}
						aria-current={isActive}
						onClick={() => handleClick(slideIndex)}>
						<div className={cx("buttonInner")} />
					</button>
				</li>
			);
	}

	return (
		<div className={cx("pagination", paginationClasses.pagination)}>
			<ul className={cx("paginationList", paginationClasses.bulletList)}>{paginationButtons}</ul>
			{moreLink}
		</div>
	);
};

SliderPagination.propTypes = {
	swiperRefLoaded: bool.isRequired,
	swiperRef: shape({ current: any }).isRequired,
	totalSlides: number.isRequired,
	paginationClasses: shape({
		pagination: string,
		paginationItem: string,
		bullet: string,
		bulletActive: string,
		autoplay: string,
	}),
	paginationBulletMessage: string,
	moreLink: node,
	slidesPerPage: number,
};

SliderPagination.defaultProps = {
	paginationClasses: {},
	paginationBulletMessage: "Go to slide {{index}}",
	moreLink: null,
	slidesPerPage: 0,
};

export default SliderPagination;
export { SliderPagination };
